export const isProduction = process.env.NODE_ENV === 'production';

// SMTP
// for production or real SMTP
export const SMTP_HOST = 'smtp.gmail.com';
export const SMTP_PORT = 465;
export const SMTP_USER = 'mpiredm@gmail.com';
export const SMTP_PASS = 'scws cvcp bwbd wpkp';

// the “to” address for contact form
export const CONTACT_TO = 'info@altracarelimited.com';

// Brand
export const companyName = 'Altracare';
export const companyFriendly = 'Altracare';

// Logos
export const logosMediaSrc = 'file' // fiel | component
export const logoAltText = `Welcome to ${companyName}`

export const logoLight = '/logo_light.svg'; // component name if logosMediaType is component
export const logoDark = '/logo_dark.svg'; // component name if logosMediaType is component
export const logoFixedLight = '/logo_light.svg'; // component name if logosMediaType is component
export const logoFixedDark = '/logo_dark.svg'; // component name if logosMediaType is component

// Header
export const headerContainerHeight = '100px';
export const headerContainerHeightFixed = '65px';

// Page Functional
export const appTitle = 'Altracare';
export const appDescription = 'Solvents Simplified';

export const siteLogo = '/logo.png';
export const siteLogoWidth = 120;
export const siteLogoHeight = 120;

export const siteUrl = 'https://Altracare.group';
export const siteImage = `${siteUrl}/images/Altracare-group.png`;
export const copyrightCompany = 'Altracare (PTY) LTD'
export const copyrightYear = '2025'



// Specific Components and Functionality


// IO Header
// When the site loads, without scrolling what is the height of the desktop header

export const ioHeader = {
  heightDefault: '100px',
  heightFixed: '65px',
  heightFixedMini: '65px', //  Fixed mini is when the header sticks for a distance but then gets smaller beyond the hero for example (later)

  // When the header should be fixed
  headerFixedTriggerType: "value", // | "element"
  headerFixedTriggerHeight: 100, // can be 100 or 100px, we need to check for string or numbers, numbers are assumed to be pixels
  headerFixedTriggerElementSelector: '' //  if element is used, this is the selector for the element
}


export const ioHeroDefaults = {
  
}


// Mega Menu
export const megaMenuThemeClass = '' // Parent class for styling, leave black for default
export const megaTabComponentsPath = '/components/io/io-mega-menu/tabs/'
export const megaMenuItems = [
  {
    label: 'Home',
    name: 'home',
    routePath: '/',
    mega: false,
    // Active states
    activeRouteName: 'index',
    activeRouteContainsName: true

  },
  {
    label: 'About',
    name: 'about',
    routePath: '/',

    mega: true,
    component: 'MegaAbout',
    // Active states
    activeRouteName: 'our-service',
    activeRouteContainsName: true,
    megaStyles: {}
  },
  {
    label: 'Solutions',
    name: 'solutions',
    routePath: '/',
    mega: true,
    component: 'MegaSolutions',
    // Active states
    activeRouteName: 'solutions',
    activeRouteContainsName: true
  },
  {
    label: 'Products',
    name: 'products',
    routePath: '/',
    mega: false,
    component: 'MegaProducts',
    // Active states
    activeRouteName: 'product',
    activeRouteContainsName: true
  },
  {
    label: 'Media',
    name: 'media',
    routePath: '/',
    mega: true,
    component: 'MegaMedia',
    // Active states
    activeRouteName: 'blog',
    activeRouteContainsName: true
  },
]


export const mobileNavigationItems = [
  {
    label: 'Home',
    name: 'home',
    type: 'route',
    routePath: '/',
    activeRouteName: 'index',
    activeRouteContainsName: false,
    children: [],
  },
  {
    label: 'Our 360 Service',
    name: 'our-service',
    type: 'route',
    routePath: '/our-service',
    activeRouteName: 'our-service',
    activeRouteContainsName: false,
    children: [],
  },
  {
    label: 'About Us',
    name: 'about-us',
    type: 'route',
    routePath: '/about-us',
    activeRouteName: 'about-us',
    activeRouteContainsName: false,
    children: [],
  },
  {
    label: 'Products',
    name: 'products',
    type: 'route',
    routePath: '',
    activeRouteName: 'products',
    activeRouteContainsName: true,
    children: [
      {
        label: 'All Products',
        name: 'products-all',
        type: 'route',
        routePath: '/products',
        activeRouteName: 'products',
        activeRouteContainsName: true,
        children: [],
      },
    ],
  },
  {
    label: 'Services',
    name: 'services',
    type: 'route',
    routePath: '/services',
    activeRouteName: 'services',
    activeRouteContainsName: false,
    children: [],
  },
  {
    label: 'Contact Us',
    name: 'contact-us',
    type: 'route',
    routePath: '/contact-us',
    activeRouteName: 'contact-us',
    activeRouteContainsName: false,
    children: [],
  },
]

// The point at which the mobile menu turns in the desktop menu
export const mobileMenuSnapPoint = 1024; // needs to be a number
